import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { useSelector, shallowEqual } from 'react-redux';

import {
  selectDirectDebitData,
  selectDetails
} from 'state/direct-debit/direct-debit-slice';

export const usePaymentPayload = () => {
  const {
    paymentMethodNEP,
    isMonthlyDirectDebit,
    isQuaterylyVariableDirectDebit
  } = usePaymentMethod();
  const directDebit = useSelector(selectDirectDebitData, shallowEqual);
  const { paymentDate } = useSelector(selectDetails, shallowEqual);
  const isDirectDebit = isMonthlyDirectDebit || isQuaterylyVariableDirectDebit;
  const paymentMethodData = isDirectDebit
    ? {
        paymentMethodId: directDebit.id,
        preferredPaymentDay: paymentDate
      }
    : {};

  return {
    type: paymentMethodNEP,
    ...paymentMethodData
  };
};
